// Route metadata is shared by Vue Router and the static-page build.
const publicRoutes = [
  { path: '/', name: 'frontpage', meta: { staticDocument: true, title: 'CVR API til apps og AI-agenter · Danske virksomhedsdata | cvr.dev', description: 'REST API til danske CVR-data: virksomheder, regnskaber, ejerskab, roller, ansatte og målgruppesøgning. JSON, OpenAPI 3.0, demo uden API-nøgle og 30 dages gratis prøveperiode.' } },
  { path: '/prices/', name: 'prices', meta: { staticDocument: true, title: 'Priser og abonnementer til CVR API - cvr.dev', description: 'Sammenlign Starter, Business og Business Pro. Se priser ved månedlig og årlig betaling, endpoints og forbrugsgrænser. Prøv gratis i 30 dage.' } },
  { path: '/terms/', name: 'terms', meta: { staticDocument: true, title: 'Handelsbetingelser og privatlivspolitik - cvr.dev', description: 'Læs cvr.devs handelsbetingelser og privatlivspolitik, herunder betaling, opsigelse og behandling af personoplysninger.' } },
];

const appRoutes = [
  { path: '/auth/signup', name: 'signup', meta: { title: 'Opret konto hos cvr.dev - API til data fra CVR' } },
  { path: '/auth/signin', name: 'signin' },
  { path: '/auth/signout', name: 'signout' },
  { path: '/auth/forgotpassword', name: 'forgotpassword' },
  { path: '/auth/resetpassword', name: 'resetpassword' },
  { path: '/app/apikeys', name: 'apikeys' },
  { path: '/app/profile', name: 'profile' },
  { path: '/app/subscription', alias: ['/app/prices', '/app/pricing'], name: 'subscription', meta: { title: 'Vælg abonnement - cvr.dev' } },
];

module.exports = { publicRoutes, appRoutes };
